package com.example.monetix.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.window
import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine

actual class LocationTracker {
    actual suspend fun getCurrentLocation(): GpsLocation? = suspendCoroutine { continuation ->
        try {
            // 🚀 Il bypass magico: asDynamic() dice a Kotlin di spegnere i controlli
            val navigator = window.navigator.asDynamic()

            // Controlliamo che il browser supporti il GPS
            if (navigator.geolocation != null) {
                navigator.geolocation.getCurrentPosition(
                    { position: dynamic -> // Callback di Successo
                        val lat = position.coords.latitude as Double
                        val lon = position.coords.longitude as Double
                        continuation.resume(GpsLocation(lat, lon))
                    },
                    { error: dynamic -> // Callback di Errore (Permesso negato, ecc.)
                        continuation.resume(null)
                    }
                )
            } else {
                // GPS non supportato dal browser
                continuation.resume(null)
            }
        } catch (e: Exception) {
            continuation.resume(null)
        }
    }
}

@Composable
actual fun rememberLocationTracker(): LocationTracker {
    return remember { LocationTracker() }
}